import React, { useEffect, useState } from 'react'
import Button from 'app/modules/shared/components/button'
import { useResponsive } from 'app/modules/shared/hooks/use-responsive'

export function ButtonAll({
  id,
  count,
  text,
  parentClass = 'summary-card',
  className,
  onClick,
}: {
  id: string
  count?: number
  text: string
  parentClass?: string
  className?: string
  onClick?: () => void
}): JSX.Element {
  const ref = React.useRef<HTMLButtonElement>(null)
  const [isMobile, setIsMobile] = useState<boolean>()
  const switchWidth = 400 // Width at which the button should switch to small size
  const { windowWidth } = useResponsive()

  const smallClass = isMobile ? 'small' : ''
  const mobileClass = typeof isMobile === 'undefined' ? 'd-none' : smallClass
  const fullClass = `navigate-button ${mobileClass} ${className ?? ''}`

  // Check if the button should be small based on the containing card width
  useEffect(() => {
    const card = ref.current?.closest('.' + parentClass)
    const cardWidth = card?.getBoundingClientRect().width || -1
    setIsMobile(cardWidth > 0 && cardWidth < switchWidth)
  }, [windowWidth])

  return (
    <Button id={id} variant="secondary" onClick={onClick} className={fullClass} ref={ref}>
      <span className="text m-0">
        {text}
        {count ? ` (${count})` : ''}
      </span>
      <span className="arrow">
        <i className="ds3-icon ds3-forward" />
      </span>
    </Button>
  )
}
